export const tic_tac_toe = {
  product_id: "9",
  grid_type: "1",
  cover_image: "/1.jpg",
  product_name: "Tic Tac Toe - Set",
  media: ["1.jpg", "2.jpg", "3.jpg", "4.jpg"],
  product_price: 19.9,
  product_slug: "tic-tac-toe",
  short_description: "Das Tic Tac Toe-Set kombiniert klassisches Gameplay mit moderner Eleganz. Gefertigt aus hochwertigem Acrylglas mit diamantgeschliffenen Rändern, verleiht es dem zeitlosen Spiel einen stilvollen und luxuriösen Touch – perfekt für Zuhause, das Büro oder als besonderes Geschenk.",
  description: `
  Verbinden Sie das klassische Spiel mit moderner Eleganz
  <br><br>
  Wir stellen unseren exquisiten Tic Tac Toe-Set vor, eine Verschmelzung von klassischem Gameplay und modernem Design, die von einem Team erfahrener Architekten entworfen wurde. Bereiten Sie sich auf eine Reise der Raffinesse mit diesem innovativen Set vor, das mit seinen hochwertigen Plexiglasplatten dem zeitlosen Spiel, das Sie so lieben, einen eleganten und modernen Touch verleiht.
  <br><br>
  Erleben Sie stundenlangen Spaß mit Freunden und Familie bei diesem beliebten Zeitvertreib. Unser Tic Tac Toe-Set ist nicht nur ein Spiel, sondern auch ein Statement in Sachen Stil und Qualität, das Ihr Zuhause, Ihr Büro oder jeden anderen Raum aufwertet.
  <br><br>
  Unser mit Präzision und Kunstfertigkeit gefertigter Tic Tac Toe-Set fängt die Essenz des klassischen Spiels ein und trägt einen Hauch moderner Eleganz. Die hochwertigen Materialien und die sorgfältige Verarbeitung garantieren Langlebigkeit und dauerhafte Schönheit.
  <br><br>
  Entdecken Sie die Freude am Spielen mit einem Hauch von Raffinesse neu. Erhöhen Sie Ihr Spielerlebnis mit unserem Tic Tac Toe Set, bei dem Tradition auf Innovation trifft, und schaffen Sie bleibende Erinnerungen mit Ihren Liebsten.
  <br><br>
  <h6> PRODUKTPFLEGE </h6>
  Um das makellose Aussehen Ihres "Tic Tac Toe"-Sets zu erhalten, verwenden Sie ein weiches, trockenes Tuch, um Staub zu entfernen, der sich im Laufe der Zeit ansammeln kann. So sieht Ihr Neujahrsferien-Set am besten aus und behält seine transparente Brillanz.
  <br><br>
  Wenn Sie diese Pflegerichtlinien befolgen, können Sie sicherstellen, dass Ihr " Tic Tac Toe " weiterhin glänzt und Ihre Inneneinrichtung über Jahre hinweg bereichert.
  `,
  specifications: {
    rows: [
      { name: "Material", value: "Hochwertiges Acrylglas" },
      { name: "Abmessungen", value: "12cm x 12cm x 2cm" },
      { name: "Gewicht", value: "190 Gramm" },
      { name: "Farbe", value: "Transparent" },
      { name: "Ränder", value: "Diamantgeschliffen" },
    ],
    description: `Diese Angaben unterstreichen die hochwertige Qualität und Präzision Ihres „Tic Tac Toe-Sets". Sie machen potenziellen Kunden deutlich, was sie in Bezug auf Material, Größe, Gewicht, Farbe und Ausführung erwarten können.`,
  },
  category: "Table",
  title_color: "#ffffff",
  subtitle_color: "#999999",
  price_color: "#ffffff"
};
